// extracted by mini-css-extract-plugin
export var carrierIcon = "_tn-0";
export var carrierLogo = "_tn-1";
export var detailsSection = "_tn-2";